import styled from 'styled-components';
import { THEME_COLORS } from '../utils/theme';

export const PrimaryFont = styled.span<{ bold?: boolean }>`
  font-family: 'Work Sans', sans-serif;
  font-weight: ${props => (props.bold ? 700 : 400)};
  color: ${THEME_COLORS.text};
`;

export const TaglineFont = styled.span<{ bold?: boolean }>`
  font-family: 'Work Sans', sans-serif;
  font-weight: 700;
  color: ${THEME_COLORS.brandPinkFaded};
`;

PrimaryFont.defaultProps = {
  bold: false,
};

export const LogoFont = styled.span`
  font-family: 'Gemunu Libre', sans-serif;
  font-weight: 800;
  color: ${THEME_COLORS.brandPink};

  user-select: none;
`;
